import { render, staticRenderFns } from "./ExtChannelList.vue?vue&type=template&id=57a850a8"
import script from "./ExtChannelList.vue?vue&type=script&lang=js"
export * from "./ExtChannelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports